import * as React from "react";
import { graphql } from "react-apollo";
import { Helmet } from "react-helmet";
import { Link, withRouter } from "react-router-dom";
import { Redirect, RouteComponentProps } from "react-router";
import styled from "@emotion/styled";
import * as jwtDecode from "jwt-decode";
import { Button } from "reactstrap";

// GraphQL
import VerifyUserEmailMutation from "../../GraphQL/Mutations/VerifyUserEmail";

// Utils
import { validateToken } from "../../Utils/Helpers";

// Presentation/UI
import LottieWrapper from "../../Components/Anim/LottieWrapper";

// Theme
import { Colors } from "../../Themes";

interface IPathParams {
  token: string;
}

type PropsType = RouteComponentProps<IPathParams> & {
  computedMatch: {
    params: {
      token: string;
    };
  };
  mutate: any;
};

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  background: ${Colors.snow};
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-size: cover;
  background-position: 50% 50%;
  z-index: -1;
  padding: 0;
  margin: 0;
  flex-direction: column;
`;

class VerifyEmail extends React.Component<PropsType> {
  state = {
    verified: false,
    loading: false
  };

  componentDidMount() {
    this.verifyUserEmailAddress();
  }

  // Render view
  renderView = (): React.ReactNode => {
    const { loading, verified } = this.state;

    if (loading) {
      return (
        <div>
          <LottieWrapper
            loop={true}
            width={140}
            height={140}
            anim={require("../../LottieFiles/loading_circle.json")}
          />
          <br />
          <br />
          <p className="center-align">Please wait...</p>
        </div>
      );
    }

    if (verified) {
      return (
        <div>
          <LottieWrapper
            loop={false}
            width={220}
            height={220}
            anim={require("../../LottieFiles/success1.json")}
          />
          <br />
          <br />
          <p className="center-align">
            Your account has been verified successfully!
          </p>
          <br />
          <Link to="/sign-in">
            <Button>Go to Login</Button>
          </Link>
        </div>
      );
    }

    return null;
  };

  // Verify user email
  verifyUserEmailAddress = (): void => {
    const { computedMatch } = this.props;
    this.setState({ loading: true });
    // Decode token
    const decodedJwt: any = jwtDecode(computedMatch.params.token);

    this.props
      .mutate({
        variables: {
          id: decodedJwt.userId
        }
      })
      .then((res: any) => {
        // Handle successful response
        this.setState({
          loading: false,
          verified: true
        });
      })
      .catch((err: any) => {
        // Do something with error message
        console.log(err);
        this.setState({ loading: false });
      });
  };

  render() {
    const { computedMatch } = this.props;
    // redirect if the token is invalid
    if (!validateToken(computedMatch.params.token)) {
      return <Redirect to="/" />;
    }

    return (
      <Wrapper>
        {this.renderView()}
        <Helmet title="Verify Email" />
      </Wrapper>
    );
  }
}

export default graphql(VerifyUserEmailMutation)(withRouter(VerifyEmail));



// WEBPACK FOOTER //
// ./src/Containers/VerifyEmail/index.tsx